import React from "react";
import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";

export default function Contact() {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative py-24 md:py-32"
    >
      <div className="container-x grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        {/* Left column: intro + contact details */}
        <div className="lg:col-span-5 reveal">
          <div className="eyebrow mb-5">
            <span>Contact</span>
          </div>
          <h2 className="font-display text-[var(--text-primary)] text-4xl md:text-5xl leading-[1.08] font-medium">
            Hai să discutăm despre{" "}
            <span className="text-brand-blue italic">proiectul tău</span>.
          </h2>
          <p className="mt-5 text-[var(--text-secondary)] text-base md:text-lg leading-relaxed max-w-md">
            Sună-ne sau scrie-ne pe WhatsApp — îți răspundem rapid și îți
            oferim o estimare corectă pentru lucrare.
          </p>

          <div className="mt-10 space-y-5">
            <ContactRow
              icon={Phone}
              label="Telefon"
              value="0746 329 111"
              href="tel:0746329111"
              testid="contact-phone"
            />
            <ContactRow
              icon={Mail}
              label="Email"
              value="aurelcalin32@gmail.com"
              href="mailto:aurelcalin32@gmail.com"
              testid="contact-email"
            />
            <ContactRow
              icon={MapPin}
              label="Zonă acoperită"
              value="Constanța și împrejurimi"
              testid="contact-area"
            />
          </div>

          <div className="mt-10 flex flex-col sm:flex-row gap-3">
            <a
              href="tel:0746329111"
              data-testid="contact-call-btn"
              className="btn-gold justify-center"
            >
              <Phone className="h-4 w-4" strokeWidth={2.6} />
              Sună acum
            </a>
            <a
              href="https://wa.me/40746329111"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-whatsapp-btn"
              className="btn-whatsapp justify-center"
            >
              <MessageCircle className="h-4 w-4" strokeWidth={2.4} />
              Contactează-ne pe WhatsApp
            </a>
          </div>
        </div>

        {/* Right column: showcase image */}
        <div className="lg:col-span-7 reveal">
          <div
            data-testid="contact-image-wrap"
            className="relative rounded-2xl overflow-hidden border border-[var(--border-subtle)] shadow-[0_30px_80px_-20px_rgba(0,0,0,0.25)] bg-[var(--bg-card)]"
          >
            <div className="aspect-[4/3] w-full">
              <img
                src="/images/contact-parquet.webp"
                alt="Montaj gresie porțelanată cu efect travertin — lucrare Aurel Calin Premium"
                className="h-full w-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function ContactRow({ icon: Icon, label, value, href, testid }) {
  const inner = (
    <>
      <div className="h-11 w-11 rounded-xl bg-[rgba(30,95,217,0.10)] border border-[rgba(30,95,217,0.35)] flex items-center justify-center flex-shrink-0">
        <Icon className="h-5 w-5 text-brand-blue" strokeWidth={2.2} />
      </div>
      <div>
        <div className="text-[11px] uppercase tracking-[0.2em] text-[var(--text-muted)]">
          {label}
        </div>
        <div className="mt-1 text-[var(--text-primary)] text-base md:text-lg font-medium">
          {value}
        </div>
      </div>
    </>
  );
  return href ? (
    <a
      href={href}
      data-testid={testid}
      className="flex items-center gap-4 group hover:opacity-90 transition-opacity"
    >
      {inner}
    </a>
  ) : (
    <div data-testid={testid} className="flex items-center gap-4">
      {inner}
    </div>
  );
}
